export default {"src":"/_next/static/media/carOutline50_24.b08d34d0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};